export default __webpack_public_path__ + "static/40th-logo-eb430759fb48ff527fab92eba970ea95.png";